
function Footer(){
    return <div id="contat" className="py-4 bg-secondary text-center text-white">&copy; Sanjay Portfolio 2025</div>
}
export default Footer